export default "__VITE_ASSET__BGqSxFVz__"